export default __webpack_public_path__ + "static/media/satishmedia.63c05bc8.jpg";